import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-product-tags-and-navigation',
    imports: [RouterLink],
    templateUrl: './product-tags-and-navigation.component.html',
    styleUrl: './product-tags-and-navigation.component.scss'
})
export class ProductTagsAndNavigationComponent {

}
